import { VoteType } from '@/actions/dtos/tender/vote';
import { createTenderVoteServer, deleteTenderVoteServer } from '@/actions/tenderVote';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const createTenderVote = async (
  tenderId: string,
  searchExecutionId: string,
  voteType: VoteType,
  reason?: string,
) => {
  const userAccessToken = await getUserAccessToken();
  return createTenderVoteServer(userAccessToken, tenderId, searchExecutionId, voteType, reason);
};

export const deleteTenderVote = async (tenderVoteId: string) => {
  const userAccessToken = await getUserAccessToken();
  return deleteTenderVoteServer(userAccessToken, tenderVoteId);
};
